const formatPercentage = (value, fixed = 3) => {
  return parseFloat(value).toFixed(fixed) + " %";
};

export default formatPercentage;
